var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-5",attrs:{"elevation":"0"}},[(_vm.isPdf && !_vm.isTooLarge)?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPortfolio),expression:"isPortfolio"}]},[_c('p',{staticClass:"styled-text",domProps:{"innerHTML":_vm._s(
          _vm.$t(
            _vm.hasEmbeddedFiles
              ? 'pdfPortfolioViewerNotice'
              : 'nonPdfViewerNotice'
          )
        )}})]),_c('vue-pdf-embed',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPortfolio),expression:"!isPortfolio"}],attrs:{"source":_vm.pdfsrc},on:{"loaded":_vm.onPdfLoaded}})]:(_vm.isPdf && _vm.isTooLarge)?_c('div',[_c('p',{staticClass:"styled-text",domProps:{"innerHTML":_vm._s(
        _vm.$t('pdfTooLargeViewerNotice', {
          sizeMB: _vm.sizeMB,
          PDF_MAX_SIZE_MB: _vm.PDF_MAX_SIZE_MB,
        })
      )}})]):(_vm.isRtf)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.rtfHtml)}}):_c('div',[_c('p',{staticClass:"styled-text",domProps:{"innerHTML":_vm._s(_vm.$t('nonPdfViewerNotice'))}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }